export default __webpack_public_path__ + "static/media/agendamento.4b711f6a.svg";